<template>
  <a></a>
</template>

<script>
export default {
  name: "ReportPage"
}
</script>

<style scoped>

</style>